// extracted by mini-css-extract-plugin
export default {"list":"list_list__mJQSf","list__item":"list_list__item__cxnMA"};